import { useLocation } from 'react-router-dom';

export const useDoesToolRequireLinkedTasks = (): boolean => {
  const { pathname } = useLocation();
  return doesToolRequireLinkedTasks(pathname);
};

/**
Only Legacy Scene Enrichment requires linked tasks
 */
export const doesToolRequireLinkedTasks = (pathname: string): boolean => {
  return pathname.includes('/scene-enrichment-legacy');
};
